export const getRelativeTimeString = (date: string | Date): string => {
  const postDate = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();
  const diffInMs = now.getTime() - postDate.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60);
  const diffInDays = diffInHours / 24;

  // Less than 1 hour
  if (diffInHours < 1) {
    return 'Just now';
  }
  
  // Less than 24 hours
  if (diffInHours < 24) {
    const hours = Math.floor(diffInHours);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }
  
  // Less than 7 days
  if (diffInDays < 7) {
    const days = Math.floor(diffInDays);
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  }
  
  // Less than 30 days
  if (diffInDays < 30) {
    const weeks = Math.floor(diffInDays / 7);
    return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
  }
  
  // More than 30 days
  const months = Math.floor(diffInDays / 30);
  if (months < 12) {
    return `${months} ${months === 1 ? 'month' : 'months'} ago`;
  }
  
  // More than a year
  const years = Math.floor(months / 12);
  return `${years} ${years === 1 ? 'year' : 'years'} ago`;
};

export const formatNumberWithCommas = (num: number): string => {
  return num.toLocaleString('en-US');
};

export const formatAbbreviatedNumber = (num: number): string => {
  if (num >= 1000000) {
    const millions = num / 1000000;
    return millions % 1 === 0 
      ? `${millions}M` 
      : `${millions.toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    const thousands = num / 1000;
    return thousands % 1 === 0 
      ? `${thousands}k` 
      : `${thousands.toFixed(1).replace(/\.0$/, '')}k`;
  }
  return num.toString();
};
